@if (rota && !loading) {
  <div>
    <app-rota-week-select [weekId]="weekId()" [showLinks]="showLinks()"></app-rota-week-select>
    <div class="alert alert-info" role="alert">
      @for (managerSettings of canDoSalesByEmployee | keyvalue; track managerSettings) {
        <span>
          {{ managerSettings.key.role | enumParse }} {{ managerSettings.key.name }} is@if (!managerSettings.value) {
          <span> not</span>
        } a salesperson.
        </span>
      }
    </div>
    <table class="table table-bordered">
      <thead>
      <tr>
        <th></th>
        @for (weekday of weekdays; track weekday) {
          <ng-container
                  *ngTemplateOutlet="dateCell; context: {$implicit: weekday,
                isUnderStaffed: isUnderStaffed(weekday),
                isOverStaffed: isOverStaffed(weekday)}">
          </ng-container>
        }
        <th>
          vs<br>
          Contractual<br>
          Hours
        </th>
      </tr>
      </thead>
      <tbody>
      @for (employee of employees; track employee) {
        <tr>
          <td>
            <div class="employee-name">
              <a routerLink="/employees/{{dataService.selectedStore.slug}}/{{employee.employeePositionId.parseEmployeeId()}}/{{employee.employeePositionId.parsePositionId()}}">{{ employee.name }}</a>
            </div>
            @if (workingHoursByEmployee.get(employee.employeePositionId.value)) {
              <div class="employee-working-hours">
                {{ workingHoursByEmployee.get(employee.employeePositionId.value) }} hrs
              </div>
            }
          </td>
          @for (weekday of weekdays; track weekday) {
            @if (anyWorkAssignmentExists(weekday, employee)) {
              <td
                      (click)="navigateToDay(weekday)"
                      class="assignment-cell"
                      [ngClass]="{'pink-background': isUnderStaffed(weekday), 'light-green-background': isOverStaffed(weekday)}">
                <app-rota-week-work-day
                        [dayOfWeek]="weekday"
                        [employeePositionId]="employee.employeePositionId"
                        [rota]="rota">
                </app-rota-week-work-day>
              </td>
            } @if (!anyWorkAssignmentExists(weekday, employee)) {
              <td
                      (click)="navigateToDay(weekday)"
                      class="no-assignment-cell"
                      [ngClass]="{'no-assignment-cell-pink-background': isUnderStaffed(weekday),
                          'no-assignment-cell-light-green-background': isOverStaffed(weekday),
                          'simpler-background': !showLinks()}">
                <app-rota-week-holiday
                        class="absence-type"
                        [dayOfWeek]="weekday"
                        [employeePositionId]="employee.employeePositionId"
                        [rota]="rota">
                </app-rota-week-holiday>
              </td>
            }
          }
          <ng-container
                  *ngTemplateOutlet="workingHoursVsContract;
                context: {$implicit: getEmployeeWorkingHoursVsContract(employee)}">
          </ng-container>
        </tr>
      }
      <tr>
        <td class="total-working-hours">TOTAL {{ totalWorkingHours }} HRS</td>
        @for (weekday of weekdays; track weekday) {
          <td class="working-hours-by-date">
            {{ workingHoursByDay.get(weekday) }} hrs
          </td>
        }
        <td class="total-working-hours-vs-contract" ngbTooltip="Total working hours vs contract">
          @if (totalWorkingHoursVsContract > 0) {
            <span>+</span>
          }{{ totalWorkingHoursVsContract }} hrs
        </td>
      </tr>
      </tbody>
    </table>
  </div>
}

<ng-template #dateCell let-weekday let-isUnderStaffed="isUnderStaffed" let-isOverStaffed="isOverStaffed">
  <th [ngClass]="{'under-staffed-warning': isUnderStaffed > 0,
                  'over-staffed-warning': isOverStaffed > 0 && !isUnderStaffed}"
      (click)="navigateToDay(weekday)">
    <div class="weekday">
      {{ weekday | dayOfWeekParse }}
    </div>
    <div class="date">{{ convertToDate(weekday) | dateParse | dateFormat: 'DD MMM' }}</div>
  </th>
</ng-template>

<ng-template #workingHoursVsContract let-diff>
  <td class="working-hours-vs-contract text-white"
      [ngClass]="{'green-background': diff > 0, 'gray-background': diff === 0, 'red-background': diff < 0}">
    @if (diff > 0) {
      <span>+</span>
    }{{ diff }}
    @if (diff === 1 || diff === -1) {
      <span>hr</span>
    } @if (diff > 1 || diff < -1) {
    <span>hrs</span>
  }
  </td>
</ng-template>
